import { useCallback, useState } from 'react';
import { toast } from '@/components/ui/toaster.jsx';
import { createPaperDraft } from '@/services/deals.service.js';

// "Regenerate the binder" (David 2026-11-01: "one press regenerates, then opens the review. The button does what it says.").
// One press renders a fresh paperwork DRAFT through the existing draft door (POST /deals/:id/paper-drafts, mode 'draft' on the
// server; approveDraft stays the only file step) and answers the new draft's id, so the caller opens the review on it. While it
// runs `regenerating` is true (the button says so); a failed render answers null, sets `failure` to why, says it in a toast,
// and the caller opens nothing.
export function useRegenerateBinder(dealId) {
  const [regenerating, setRegenerating] = useState(false);
  const [failure, setFailure] = useState(null);
  const regenerate = useCallback(async () => {
    if (!dealId) return null;
    setRegenerating(true); setFailure(null);
    try {
      const res = await createPaperDraft(dealId);
      const id = res?.draft?.id || null;
      if (!id) throw new Error('the draft door answered no draft');
      toast.success('A fresh binder draft is rendered. Review it, then Approve & file.');
      return id;
    } catch (e) {
      const why = e?.body?.error || e?.message || 'unknown error';
      setFailure(why);
      toast.error(`The binder was not regenerated: ${why}. Nothing was opened.`);
      return null;
    } finally {
      setRegenerating(false);
    }
  }, [dealId]);
  return { regenerating, failure, regenerate };
}
